import React, { CSSProperties, isValidElement } from 'react';
import { makeStyles } from '@material-ui/styles';
import { MDSTooltip, MDSTooltipProps, MDSTypography, MDSTypographyProps } from '@marqvision/mds-v2';

const useStyles = makeStyles(({ _raw_color }) => ({
  text: {
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationColor: _raw_color.blackAlpha30,
    textDecorationThickness: '1px',
    textUnderlineOffset: '2px',
  },
}));

type Props = {
  width?: string;
  wrapperStyle?: CSSProperties;
  tooltipTitle: React.ReactElement | string;
  tooltipPosition?: MDSTooltipProps['position'];
} & MDSTypographyProps;

export const UnderlineTooltip = (props: React.PropsWithChildren<Props>) => {
  const { tooltipTitle, children, width, wrapperStyle, tooltipPosition, as, ...restProps } = props;
  const classes = useStyles();
  const wrapperTag = isValidElement(children) ? 'div' : as;

  return (
    <div style={{ display: 'flex', ...wrapperStyle }}>
      <MDSTooltip title={tooltipTitle} position={tooltipPosition} width={width}>
        <MDSTypography className={classes.text} as={wrapperTag} {...restProps}>
          {children}
        </MDSTypography>
      </MDSTooltip>
    </div>
  );
};
